import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Stack,
  SvgIcon,
  TextField,
  Typography,
} from '@mui/material';
import { Plus, Save01 } from '../../../assets';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

interface Props {
  open: boolean;
  onClose: () => void;
  isSubmitZoneProcessing: boolean;
  isErrorNameTxtF: boolean;
  errorNameTxtFDescr: string;
  nameTxtFValue: string;
  handleNameTextFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddNewZoneConfirm: () => void;
  handleEditZoneConfirm: () => void;
  error: string;
  isSubmitBtnDisabled: boolean;
  candidateZoneToEdit?: number
}

const StockCountZonesCreateEditDialog: React.FC<Props> = ({
  open,
  onClose,
  isSubmitZoneProcessing,
  isErrorNameTxtF,
  errorNameTxtFDescr,
  nameTxtFValue,
  handleNameTextFieldChange,
  handleAddNewZoneConfirm,
  handleEditZoneConfirm,
  error,
  isSubmitBtnDisabled,
  candidateZoneToEdit,
}) => {

  const { t } = useTranslation('stockCountZones');

  return (
    <Dialog open={open}
      fullWidth
      onClose={onClose}
      aria-labelledby={candidateZoneToEdit ? 'edit-zone-dialog-title' : 'create-zone-dialog-title'}>
      <DialogTitle>
        <Typography variant="textXL"
          sx={{ display: 'flex', flex: 1, justifyContent: 'left', alignItems: 'center' }}>
          {candidateZoneToEdit ? t('editDialog.title') : t('createDialog.title')}
        </Typography>
        <CloseDialogAction onCancel={onClose} />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Stack spacing={5}>
          <FormControl size='small'>
            <TextField
              id="zone-name-field"
              error={isErrorNameTxtF}
              helperText={errorNameTxtFDescr}
              label={candidateZoneToEdit ? t('editDialog.txtFName') : t('createDialog.txtFName')}
              size='small'
              variant="outlined"
              value={nameTxtFValue}
              onChange={handleNameTextFieldChange}
              disabled={isSubmitZoneProcessing}
              required
            />
          </FormControl>
          {isSubmitZoneProcessing && <Alert severity="info">
            {candidateZoneToEdit ? t('editDialog.processingMessage') : t('createDialog.processingMessage')}
          </Alert>}
          {!isSubmitZoneProcessing && error !== '' && <Alert severity="error">
            {error}
          </Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='secondary'
          size="lg"
          disabled={isSubmitZoneProcessing}
          onClick={onClose}>
          {candidateZoneToEdit ? t('editDialog.cancelButton') : t('createDialog.cancelButton')}
        </Button>
        <Button variant='primary'
          size="lg"
          startIcon={candidateZoneToEdit ? <SvgIcon><Save01 fill='white' /></SvgIcon> : <SvgIcon><Plus fill='white' /></SvgIcon>}
          disabled={isSubmitZoneProcessing || isSubmitBtnDisabled}
          onClick={candidateZoneToEdit ? handleEditZoneConfirm : handleAddNewZoneConfirm}>
          {candidateZoneToEdit ? t('editDialog.confirmButton') : t('createDialog.confirmButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountZonesCreateEditDialog;
